var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ChartBlockTrend } from '../svg-elements/module';
import { getNeededColumnsForHistoryV2 } from '../d3-services/data-with-history.functions';
import { GraphControllerV2 } from './graph-v2';
import { flattenColumn } from '../d3-services/_helpers';
var ShortTrend = /** @class */ (function (_super) {
    __extends(ShortTrend, _super);
    function ShortTrend(main, data, element, mapping, segment) {
        var _this = _super.call(this, main, data, element, mapping, segment) || this;
        _this.main = main;
        _this.data = data;
        _this.element = element;
        _this.mapping = mapping;
        _this.segment = segment;
        _this.pre();
        return _this;
    }
    ShortTrend.prototype.pre = function () {
        this.parameters.x = flattenColumn(this.mapping.parameters[0][0].column);
        this._addScale("x", "band", "horizontal", this.mapping.args[0]); // week en maand 
        this._addScale("y", "linear", "vertical", this.parameters.x);
        this._addAxis("x", "x", "bottom", "ktomaandcijfer");
        this._addMargin(0, 0, 0, 0);
        this._addPadding(10, 0, 10, 10);
    };
    ShortTrend.prototype.init = function () {
        _super.prototype._init.call(this);
        var svgId = "svg-wrapper-" + this.mapping.slug;
        var container = document.createElement('section');
        container.style.height = "160px";
        container.style.width = "100%";
        container.id = svgId;
        this.element.appendChild(container);
        _super.prototype._svg.call(this, container);
        this.config.paddingInner = 0.1;
        this.config.paddingOuter = 0;
        this.config.extra.decimal = true;
        if (this.mapping.args[0] === "_month") {
            this.config.extra.axisInMonths = true;
        }
        this.chartBlockTrend = new ChartBlockTrend(this);
        this.update(this.data, this.segment, false);
    };
    ShortTrend.prototype.prepareData = function (data) {
        data = data.filter(function (w) { return w["complete"]; });
        data.forEach(function (w) {
            var doubleDigitMonth = w._month < 10 ? "0" + w._month.toString() : w._month.toString();
            w._yearmonth = parseInt(w._year.toString() + doubleDigitMonth);
            w["maand_n"] = w["fysieke_schade_aantal_respondenten"] + w["waardedaling_aantal_respondenten"] + w["ims_aantal_respondenten"] + w["ves_aantal_respondenten"];
        });
        var neededColumns = getNeededColumnsForHistoryV2(data, this.mapping);
        neededColumns = neededColumns.concat(["_yearmonth", "maand_n"]);
        var history = data; // groupByMonths(data,neededColumns);
        this.main.dataStore.setGraph(this.mapping.slug, history);
        return {
            "history": history,
            "latest": data[0],
            "slice": history.slice(0, 10).reverse(),
        };
    };
    ShortTrend.prototype.redraw = function (data) {
        _super.prototype.redraw.call(this, data);
        this.chartBlockTrend.redraw();
    };
    ShortTrend.prototype.draw = function (data) {
        var _this = this;
        this.scales.x.set(data.slice.map(function (m) { return m[_this.parameters.x]; }));
        this.scales.y.set(data.slice.map(function (m) { return m[_this.parameters.y]; }), 0);
        this.chartBlockTrend.draw(data.slice);
        this.popup.attachData([data.latest]);
    };
    ShortTrend.prototype.update = function (data, segment, update) {
        _super.prototype._update.call(this, data, segment, update);
    };
    return ShortTrend;
}(GraphControllerV2));
export default ShortTrend;
